import { PlanNames } from '@va/constants';
import classNames from 'classnames';

export const PlanIcon = ({
  planName,
  percentage,
  color,
}: {
  planName: PlanNames;
  percentage?: number;
  color: string;
}) => {
  const gradientStyle =
    planName === PlanNames.Custom
      ? 'conic-gradient(rgba(0,0,0,0.5) 0deg, rgba(0,0,0,0.5) 40deg,rgba(0,0,0,0.25) 40deg, rgba(0,0,0,0.25) 220deg, rgba(0,0,0,0.5) 220deg)'
      : `conic-gradient(${color} calc(${percentage} * 1%), #0000 0)`;

  return (
    <div
      className={classNames('p-2px w-18px h-18px shrink-0 rounded-full border-[0.0938rem] border-inherit', {
        'border-dashed': planName === PlanNames.Free,
      })}
    >
      <div className='w-full h-full rounded-full' style={{ background: gradientStyle }}></div>
    </div>
  );
};
